"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.login = login;
const __1 = require("../..");
const baseUrls_1 = require("./baseUrls");
async function login({ emailId, password, accessToken, }) {
    const url = `${baseUrls_1.AuthApiBaseUrl}/login?clientId=${baseUrls_1.clientId}`;
    const res = await (0, __1.fetchWrapper)(url, {
        method: "POST",
        body: {
            emailId,
            password,
        },
        headers: {
            Authorization: accessToken,
        },
    });
    return res.data;
}
